<template>
  <div>
     <h2 class=" ml-2 hedderLogin"  id="getting-started">
                    <a href="#getting-started" class="header-anchor">Sign</a> Up
                  </h2>
   
    <br />
    <form class="container mt-1 ml-2" style="width: 100%">
      <p>
        <label class="fontSizeData">Name</label>
        <input class="inputForm" v-model="nameregis" type="text" />
      </p>
      <p>
        <label class="fontSizeData">E-mail</label>
        <input class="inputForm" v-model="emailregis" type="text" />
      </p>

      <br />
    </form>
    <br />
    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button
          @click="signupReq"
          color="warning"
          class="container-fluid"
          type="filled"
          style="width: 65%; border-radius: 20px"
          ><h5>Create Account</h5>
        </vs-button></vs-col
      >
    </vs-row>

    <b-modal ref="my-modal2" centered hide-footer title="OTP Verification">
      <vs-row>
        <p>Enter the <a href="#">OTP</a> sent to E-mail</p>
        <vs-spacer />
        <p>
          <a class="ml-2" href="#"
            ><vs-icon icon="refresh" size="small" color="success"></vs-icon
            >Resent OTP</a
          >
        </p>
      </vs-row>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vue-otp-2
            @onChange="handleOnChange"
            @onComplete="handleOnComplete"
            class="container-fluid"
            length="6"
            join-character="-"
          />
        </vs-col>
      </vs-row>
      <br />
      <p class="text-danger" id="demo"></p>
    </b-modal>
  </div>
</template>

<script>
export default {
  data: () => ({
    active: true,
    otpcode: "",
    checkbox: false,
    nameregis: "",
    emailregis: "",
    signupId: "",
    verifyResult: "",
  }),

  methods: {
    handleOnComplete(value) {
      this.otpcode =
        value[0] + value[1] + value[2] + value[3] + value[4] + value[5];
      // console.log(this.signupId)
      // console.log('OTP completed: ', this.otpcode );

      var body = {
          column: "*",
          id: this.signupId,
          otp: this.otpcode
        };
      // console.log("signup/verify", body)
      this.$API.post("signup/verify", body, { 
      headers: {
      'Access-Control-Request-Method': '*',
      'Access-Control-Request-Headers': '*',
      'Access-Control-Allow-Origin': '*'
      },
      username: "admin",
      password: "admin",
      role: this.checkbox
      }).then((result) => {
          if(result.data == true){
            this.verifyResult = true
            this.active = true
      //       // 'register'
      //       this.$router.push('/login')
      //       this.$route.params.pathMatch 
      //       this.$router.push({
      //   name: 'Register',
      //   params: {
      //     id: this.signupId,
      //     email: this.emailregis,
      //     name: this.nameregis
      //   }
      // })
          }
          else{
            this.verifyResult = false
            document.getElementById("demo").innerHTML = "Nope, Try again.";
            // console.log("signup/verify", body)
          }
          // console.log(this.verifyResult)
        });
    },
    handleOnChange(value) {
      // // console.log('OTP changed: ', value);
    },
    signupReq() {
      this.$refs["my-modal2"].show();
      // console.log(this.nameregis)
       var body = {
          column: "*",
          name: this.nameregis,
          email: this.emailregis,
        };
        // console.log(body);
        this.$API
          .post("signup", body)
          .then((result) => {
            // console.log(result.data);
            this.signupId = result.data.id
            // console.log(this.signupId)
          })
       // console.log("signup", body)
    },
  },
};
</script>

<style>
</style>